import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import IconPicker from './IconPicker';

const SectionDefinitionFormModal = ({
  open,
  mode = 'edit',
  values,
  onChange,
  onClose,
  onSave,
  isSaving = false,
}) => {
  const isEdit = mode === 'edit';
  const name = values?.name || '';
  const icon = values?.icon || 'building';
  const generationInstructions = values?.generationInstructions || '';
  const active = values?.active !== false;
  const canSave = name.trim().length > 0 && Boolean(icon);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
      <DialogTitle sx={{ fontWeight: 700, pr: 6 }}>
        {isEdit ? 'Edit card' : 'Add card'}
        <IconButton
          onClick={onClose}
          aria-label='Close'
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, pt: '12px !important' }}>
        <TextField
          label='Card name'
          value={name}
          onChange={(event) => onChange({ ...values, name: event.target.value })}
          fullWidth
          required
        />

        <Box>
          <Typography variant='body2' fontWeight={600} mb={1}>
            Icon
          </Typography>
          <IconPicker value={icon} onChange={(next) => onChange({ ...values, icon: next })} />
        </Box>

        <TextField
            label='AI instructions for filling this card'
            value={generationInstructions}
            onChange={(event) =>
              onChange({
                ...values,
                generationInstructions: event.target.value,
              })
            }
            fullWidth
            multiline
            minRows={5}
          />

        <TextField
          label='Maximum card content length'
          type='number'
          value={values?.maxContentChars ?? 5000}
          onChange={(event) =>
            onChange({ ...values, maxContentChars: event.target.value })
          }
          fullWidth
          helperText='Maximum combined length of the card’s text entries, excluding source references and badges.'
          slotProps={{
            input: { endAdornment: <Typography variant='caption' color='text.secondary'>characters</Typography> },
            htmlInput: { min: 1 },
          }}
        />

        {values?.role === 'additional_knowledge' ? (
          <Typography variant='body2' color='text.secondary'>
            Additional Knowledge stays active and last in the grid.
          </Typography>
        ) : (
        <FormControlLabel
          control={
            <Switch
              checked={active}
              onChange={(event) => onChange({ ...values, active: event.target.checked })}
            />
          }
          label={active ? 'Active' : 'Inactive'}
        />
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>
          Cancel
        </Button>
        <Button
          variant='contained'
          onClick={onSave}
          disabled={!canSave || isSaving}
          sx={{ textTransform: 'none' }}
        >
          {isSaving ? 'Saving…' : isEdit ? 'Save changes' : 'Add card'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SectionDefinitionFormModal;
